export const getListingType = (listingTypes) => {
    let arr = listingTypes?.[0]?.split(',')
    if (arr?.[0] === 'Auction' || arr?.[0] === 'AuctionWithBIN') {
        return "Auction";
    } else {
        return "Buy It Now";
    }
}

export const sortTypes = {
    'StartTimeNewest': "Newly Listed",
    'EndTimeSoonest': "Ending Soonest",
    'BestMatch': "Best Match",
    'WatchCountDecreaseSort': "Most Watched"
};